import React, { FunctionComponent, PropsWithChildren, ReactNode } from "react";
import CursorContext from "../contexts/cursor.context";
import { CURSOR_ENUM } from "../components/Cursor";

const withCursor =
  (enterCursor: CURSOR_ENUM, leaveCursor: CURSOR_ENUM) =>
  (Component: FunctionComponent<PropsWithChildren<ReactNode>>) =>
  (props: any) => {
    return (
      <CursorContext.Consumer>
        {({ setCursor }) => (
          <div
            onMouseEnter={() => {
              setCursor(enterCursor);
            }}
            onMouseLeave={() => {
              setCursor(leaveCursor);
            }}
            style={{ height: 'fit-content', width: 'fit-content' }}
          >
            <Component {...props} />
          </div>
        )}
      </CursorContext.Consumer>
    );
  };

export default withCursor;
